import React from "react";

import { SUBDOMAIN } from "@/assets/meta/meta";

// ★501(10/31 대표님 "로그인 페이지만"): 기존 관리자(부산·김포·파주) 로그인 화면 안 "새 관리자 모드 시범 운영" 안내 칸 — 11/7까지
//   로그인 칸·로그인 방식은 그대로, 칸만 더함 · ★498 로그인 뒤 팝업은 이것으로 대신함(둘 중 하나만)
//   되돌리기: 이 파일과 Login.tsx 한 줄 빼고 재배포(이전 이미지 addb1ee^ = dbfe651)
const NEW_CRM: Record<string, string> = {
  bs: "https://crm.amzinfra.site/bsv",
  kpv: "https://crm.amzinfra.site/kpv",
  pj: "https://crm.amzinfra.site/pj",
};
const LAST_DAY = "2026-11-07";

const todayKst = () => new Date(Date.now() + 9 * 3600 * 1000).toISOString().slice(0, 10);

const NewAdminNotice = () => {
  const url = NEW_CRM[SUBDOMAIN];
  if (!url || todayKst() > LAST_DAY) return null;
  return (
    <div className="card" style={{ borderColor: "#c9d6f0" }}>
      <div className="card-body p-4">
        <h5 className="mb-2 text-base font-bold">새 관리자 모드 시범 운영 11/1(일)~11/7(토)</h5>
        <ol className="mb-3 list-none space-y-1 p-0 text-muted">
          <li>① 새 관리자 모드에 들어가 쿠폰을 1개씩 등록해 주세요(기존 아이디로 로그인).</li>
          <li>② 글 칸에는 AI로 쓰기, 사진 칸에는 AI로 만들기가 들어 있어 문구와 이미지를 바로 만들 수 있어요.</li>
          <li>③ 불편한 점은 본사로 알려 주세요.</li>
        </ol>
        <a href={url} className="btn btn-primary w-100">새 관리자 모드로 로그인 →</a>
      </div>
    </div>
  );
};

export default NewAdminNotice;
